export const formNames = {
  TipoPlantilla: "TipoPlantilla",
  PlantillaSeleccionada: "PlantillaSeleccionada",
  NombreArchivo: "NombreArchivo",
  NombrePlantilla: "NombrePlantilla"
};

